import { ToastProvider } from '@axo/ui-core/components/Toast';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { ErrorToast } from './ErrorToast';
import { getErrorCode } from './utils/getErrorCode';

type DataAccessErrorFeedbackType = {
  error: Error | null;
  setError: (error: Error | null) => void;
};

const DataAccessErrorFeedback = createContext(
  {} as DataAccessErrorFeedbackType
);

export const DataAccessErrorFeedbackProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [error, setError] = useState<Error | null>(null);

  const activeError = getErrorCode(error);

  const errorProviderValue = useMemo(
    () => ({
      error,
      setError,
    }),
    [error]
  );

  const onClose = useCallback(() => setError(null), [setError]);

  return (
    // FIXME move toast on site level – site-one ✔
    // <ToastProvider>
    <DataAccessErrorFeedback.Provider value={errorProviderValue}>
      <ErrorToast error={activeError} onClose={onClose} />

      {children}
    </DataAccessErrorFeedback.Provider>
    // </ToastProvider>
  );
};

export const useDataAccessErrorFeedback = () => {
  const context = useContext(DataAccessErrorFeedback);

  if (context === undefined) {
    throw new Error(
      'useDataAccessErrorFeedback must be used within a DataAccessErrorFeedbackProvider'
    );
  }

  return context;
};
